import { useEffect, useRef } from 'react';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';
import { getAuth } from 'firebase/auth'; // Assuming you have initialized your Firebase App

// Get the Firebase Auth instance
const firebaseAuth = getAuth();

export const AuthUI = ({ uiConfig }: any) => {
  const elementRef = useRef(null);

  useEffect(() => {
    // Check for an existing AuthUI instance or create a new one
    const firebaseUiWidget =
      firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebaseAuth);

    // Start the widget, pointing it to the div element we created
    if (elementRef.current) {
      firebaseUiWidget.start(elementRef.current, uiConfig);
    }

    // Clean-up function: This runs when the component is unmounted.
    return () => {
      // Crucial: Use .reset() to clean up the instance safely.
      firebaseUiWidget.reset();
    };
  }, [uiConfig]); // Depend on uiConfig to re-run if it changes

  // This is the DOM element where FirebaseUI renders the login form
  return <div ref={elementRef} />;
};
